import dayjs from "dayjs";
const FORMAT = "YYYY-MM-DD";


export const getInitAndEndMonth = ({ year, month }, format = FORMAT) => {
  const start = dayjs(`${year}-${month}-01`);
  const end = start.endOf("month");
  return { start: start.format(format), end: end.format(format) };
};

export const getFiltersDate = (dateFilter, format = FORMAT) => {
  const end = dayjs().format(format);

  if (dateFilter === 0) {
    return {
      start: dayjs().startOf("month").format(format),
      end
    };
  }

  return {
    start: dayjs().subtract(dateFilter, "days").format(format),
    end
  };
};

export const today = (format = "YYYY-MM-DD") => {
  return dayjs().format(format);
};

export const dateFormat = (date, format = "YYYY, MMM DD") => {
  const dateFormated = dayjs(date).format(format);

  return dateFormated;
};

export const getDateRange = (period, customDates = {}) => {
  const today = dayjs();

  switch (period) {
    case "1": // Últimas 24 horas
      return {
        from: today.subtract(1, "day").format("YYYY/MM/DD"),
        to: today.format("YYYY/MM/DD"),
      };
    case "2": // Última semana
      return {
        from: today.subtract(1, "week").format("YYYY/MM/DD"),
        to: today.subtract(1, "day").format("YYYY/MM/DD"),
      };
    case "3": // Este mes
      return {
        from: today.startOf("month").format("YYYY/MM/DD"),
        to: today.format("YYYY/MM/DD"),
      };
    case "4": // Últimos 30 días
      return {
        from: today.subtract(30, "days").format("YYYY/MM/DD"),
        to: today.format("YYYY/MM/DD"),
      };
    case "5": // Personalizado
      return {
        from: dayjs(customDates.dateFrom).format("YYYY/MM/DD"),
        to: dayjs(customDates.dateTo).format("YYYY/MM/DD"),
      };
    default: // Hoy
      return {
        from: today.startOf("day").format("YYYY/MM/DD"),
        to: today.format("YYYY/MM/DD"),
      };
  }
};

export const formatPeriodString = (start, end) => {
  return `Del ${dayjs(start).format("DD/MM/YYYY")} al ${dayjs(end).format(
    "DD/MM/YYYY"
  )}`;
};
